import { cn } from "@/lib/cn";

export function SkeletonRow({ cols = 5 }: { cols?: number }) {
  return (
    <div className="flex gap-4 border-b border-line px-4 py-3.5">
      {Array.from({ length: cols }, (_, i) => `skel-cell-${i}`).map((key, i) => (
        <div
          key={key}
          className={cn("h-3 animate-pulse rounded bg-line", i === 0 ? "w-[140px]" : "w-[80px]")}
        />
      ))}
    </div>
  );
}

export function TableSkeleton({ rows = 5, cols = 5 }: { rows?: number; cols?: number }) {
  return (
    <div className="rounded-lg border border-line bg-surface overflow-hidden">
      {Array.from({ length: rows }, (_, i) => `skel-row-${i}`).map((key) => (
        <SkeletonRow key={key} cols={cols} />
      ))}
    </div>
  );
}
